import { render, staticRenderFns } from "./ItemOrderForWeight.vue?vue&type=template&id=149b423d&lang=pug&"
import script from "./ItemOrderForWeight.vue?vue&type=script&lang=ts&"
export * from "./ItemOrderForWeight.vue?vue&type=script&lang=ts&"
import style0 from "./ItemOrderForWeight.vue?vue&type=style&index=0&id=149b423d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports